const Assessments = [
  {
    category: "water",
    id: "water_changes__rate",
    title: "Area Change rate",
    description:
      "This indicator is to reflect the change rate of surface water body area detected between the target year and the base year, which corresponds to SDG 6.6.1.",
    assessment: [
      {
        region: "HKH Region",
        year: "2000",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "HKH Region",
        year: "2010",
        number: [{ class: "", number: -18.84 }],
      },
      {
        region: "HKH Region",
        year: "2020",
        number: [{ class: "", number: 11.35 }],
      },
      { region: "China", year: "2000", number: [{ class: "", number: 9.22 }] },
      { region: "China", year: "2010", number: [{ class: "", number: 9.22 }] },
      { region: "China", year: "2020", number: [{ class: "", number: 9.22 }] },
      {
        region: "Afghanistan",
        year: "2000",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Afghanistan",
        year: "2010",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Afghanistan",
        year: "2020",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2000",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2010",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2020",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2000",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2010",
        number: [{ class: "", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2020",
        number: [{ class: "", number: 9.22 }],
      },
      { region: "Bhutan", year: "2000", number: [{ class: "", number: 9.22 }] },
      { region: "Bhutan", year: "2010", number: [{ class: "", number: 9.22 }] },
      { region: "Bhutan", year: "2020", number: [{ class: "", number: 9.22 }] },
      { region: "India", year: "2000", number: [{ class: "", number: 9.22 }] },
      { region: "India", year: "2010", number: [{ class: "", number: 9.22 }] },
      { region: "India", year: "2020", number: [{ class: "", number: 9.22 }] },
      { region: "Myanmar", year: "2000", number: [{ class: "", number: 9.22 }] },
      { region: "Myanmar", year: "2010", number: [{ class: "", number: 9.22 }] },
      { region: "Myanmar", year: "2020", number: [{ class: "", number: 9.22 }] },
      { region: "Pakistan", year: "2000", number: [{ class: "", number: 9.22 }] },
      { region: "Pakistan", year: "2010", number: [{ class: "", number: 9.22 }] },
      { region: "Pakistan", year: "2020", number: [{ class: "", number: 9.22 }] },
      { region: "Nepal", year: "2000", number: [{ class: "", number: 9.22 }] },
      { region: "Nepal", year: "2010", number: [{ class: "", number: 9.22 }] },
      { region: "Nepal", year: "2020", number: [{ class: "", number: 9.22 }] },
    ],
    decimal: 2,
    suffix: " %",
  },
  {
    category: "water",
    id: "water_good_quality_proportion",
    title: "Proportion of water bodies ",
    description:
      "It reflects the proportion of water bodies that are not harmful to ecosystem function and human health (with water clarity > 0.5 m), which corresponds to SDG 6.3.2.",
    assessment: [
      {
        region: "HKH Region",
        year: "2000",
        number: [{ class: "Good Water Quality", number: 65.37 }],
      },
      {
        region: "HKH Region",
        year: "2010",
        number: [{ class: "Good Water Quality", number: 70.06 }],
      },
      {
        region: "HKH Region",
        year: "2020",
        number: [{ class: "Good Water Quality", number: 92.35 }],
      },
      { region: "China", year: "2000", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "China", year: "2010", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "China", year: "2020", number: [{ class: "Good Water Quality", number: 9.22 }] },
      {
        region: "Afghanistan",
        year: "2000",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Afghanistan",
        year: "2010",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Afghanistan",
        year: "2020",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2000",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2010",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2020",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2000",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2010",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2020",
        number: [{ class: "Good Water Quality", number: 9.22 }],
      },
      { region: "Bhutan", year: "2000", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Bhutan", year: "2010", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Bhutan", year: "2020", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "India", year: "2000", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "India", year: "2010", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "India", year: "2020", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Myanmar", year: "2000", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Myanmar", year: "2010", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Myanmar", year: "2020", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Pakistan", year: "2000", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Pakistan", year: "2010", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Pakistan", year: "2020", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Nepal", year: "2000", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Nepal", year: "2010", number: [{ class: "Good Water Quality", number: 9.22 }] },
      { region: "Nepal", year: "2020", number: [{ class: "Good Water Quality", number: 9.22 }] },
    ],
    decimal: 2,
    suffix: " %",
  },
  {
    category: "agriculture",
    id: "yield_per_uint",
    title: "Grain yield per unit",
    description:
      "This indicator is measured in kilograms per person. The standard for the labor force population is the population between the ages of 15-64 in the area.",
    assessment: [
      {
        region: "HKH Region",
        year: "2000",
        number: [{ class: "Labor Productivity", number: 6500 }],
      },
      {
        region: "HKH Region",
        year: "2010",
        number: [{ class: "Labor Productivity", number: 6500 }],
      },
      {
        region: "HKH Region",
        year: "2020",
        number: [{ class: "Labor Productivity", number: 6500 }],
      },
      { region: "China", year: "2000", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "China", year: "2010", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "China", year: "2020", number: [{ class: "Labor Productivity", number: 9.22 }] },
      {
        region: "Afghanistan",
        year: "2000",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Afghanistan",
        year: "2010",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Afghanistan",
        year: "2020",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2000",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2010",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2020",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2000",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2010",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      {
        region: "Bangladesh",
        year: "2020",
        number: [{ class: "Labor Productivity", number: 9.22 }],
      },
      { region: "Bhutan", year: "2000", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Bhutan", year: "2010", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Bhutan", year: "2020", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "India", year: "2000", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "India", year: "2010", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "India", year: "2020", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Myanmar", year: "2000", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Myanmar", year: "2010", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Myanmar", year: "2020", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Pakistan", year: "2000", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Pakistan", year: "2010", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Pakistan", year: "2020", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Nepal", year: "2000", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Nepal", year: "2010", number: [{ class: "Labor Productivity", number: 9.22 }] },
      { region: "Nepal", year: "2020", number: [{ class: "Labor Productivity", number: 9.22 }] },
    ],
    decimal: 2,
    suffix: " Kg / Labor",
  },
  {
    category: "agriculture",
    id: "land_intensity_per_unit",
    title: "Land intensity per unit ",
    description:
      "This indicator is used to reflect how much land area required to produce one ton of grain, and it is measured in hectares per ton.",
    assessment: [
      { region: "HKH Region", year: "2000", number: "0.20" },
      { region: "HKH Region", year: "2010", number: "0.20" },
      { region: "HKH Region", year: "2020", number: "0.20" },
      { region: "China", year: "2000", number: "42.18" },
      { region: "China", year: "2010", number: "2.18" },
      { region: "China", year: "2020", number: "12.3" },
      { region: "Afghanistan", year: "2000", number: "4.1" },
      { region: "Afghanistan", year: "2010", number: "2.18" },
      { region: "Afghanistan", year: "2020", number: "1.3" },
      { region: "Bangladesh", year: "2000", number: "42.8" },
      { region: "Bangladesh", year: "2010", number: "23.18" },
      { region: "Bangladesh", year: "2020", number: "12.3" },
      { region: "Bangladesh", year: "2000", number: "2.18" },
      { region: "Bangladesh", year: "2010", number: "22.18" },
      { region: "Bangladesh", year: "2020", number: "2.3" },
      { region: "Bhutan", year: "2000", number: "2.11" },
      { region: "Bhutan", year: "2010", number: "22.12" },
      { region: "Bhutan", year: "2020", number: "2.34" },
      { region: "India", year: "2000", number: "2.16" },
      { region: "India", year: "2010", number: "22.82" },
      { region: "India", year: "2020", number: "2.12" },
      { region: "Myanmar", year: "2000", number: "2.16" },
      { region: "Myanmar", year: "2010", number: "22.82" },
      { region: "Myanmar", year: "2020", number: "2.12" },
      { region: "Pakistan", year: "2000", number: "82.1" },
      { region: "Pakistan", year: "2010", number: "52.82" },
      { region: "Pakistan", year: "2020", number: "26.12" },
      { region: "Nepal", year: "2000", number: "27.16" },
      { region: "Nepal", year: "2010", number: "22.82" },
      { region: "Nepal", year: "2020", number: "23.12" },
    ],
    decimal: 2,
    suffix: " ha / t",
  },
  {
    category: "ecology",
    id: "forest-grass_changes__ratio",
    title: "Coverage Radio",
    description:
      "It reflects the proportion of forest land and grassland coverage to the regional coverage area, providing information on forest and grassland distribution. ",
    assessment: [
      {
        region: "HKH Region",
        year: "2000",
        number: [
          { class: "Forest", number: 18.59 },
          { class: "Grass", number: 35.52 },
        ],
      },
      {
        region: "HKH Region",
        year: "2010",
        number: [
          { class: "Forest", number: 18.32 },
          { class: "Grass", number: 36.36 },
        ],
      },
      {
        region: "HKH Region",
        year: "2020",
        number: [
          { class: "Forest", number: 19.94 },
          { class: "Grass", number: 37.61 },
        ],
      },
      { region: "China", year: "2000", number: "42.18" },
      { region: "China", year: "2010", number: "2.18" },
      { region: "China", year: "2020", number: "12.3" },
      { region: "Afghanistan", year: "2000", number: "4.1" },
      { region: "Afghanistan", year: "2010", number: "2.18" },
      { region: "Afghanistan", year: "2020", number: "1.3" },
      { region: "Bangladesh", year: "2000", number: "42.8" },
      { region: "Bangladesh", year: "2010", number: "23.18" },
      { region: "Bangladesh", year: "2020", number: "12.3" },
      { region: "Bangladesh", year: "2000", number: "2.18" },
      { region: "Bangladesh", year: "2010", number: "22.18" },
      { region: "Bangladesh", year: "2020", number: "2.3" },
      { region: "Bhutan", year: "2000", number: "2.11" },
      { region: "Bhutan", year: "2010", number: "22.12" },
      { region: "Bhutan", year: "2020", number: "2.34" },
      { region: "India", year: "2000", number: "2.16" },
      { region: "India", year: "2010", number: "22.82" },
      { region: "India", year: "2020", number: "2.12" },
      { region: "Myanmar", year: "2000", number: "2.16" },
      { region: "Myanmar", year: "2010", number: "22.82" },
      { region: "Myanmar", year: "2020", number: "2.12" },
      { region: "Pakistan", year: "2000", number: "82.1" },
      { region: "Pakistan", year: "2010", number: "52.82" },
      { region: "Pakistan", year: "2020", number: "26.12" },
      { region: "Nepal", year: "2000", number: "27.16" },
      { region: "Nepal", year: "2010", number: "22.82" },
      { region: "Nepal", year: "2020", number: "23.12" },
    ],
    decimal: 2,
    suffix: " %",
  },
  {
    category: "ecology",
    id: "fvc",
    title: "Fractional Vegetation Cover",
    description:
      "It is the average of Fractional Vegetation Cover calculated in 2000, 2010 and 2020, providing information on forest and grassland greenness in the region.",
    assessment: [
      { region: "HKH Region", year: "2000", number: "39.12" },
      { region: "HKH Region", year: "2010", number: "44.47" },
      { region: "HKH Region", year: "2020", number: "50.85" },
      { region: "China", year: "2000", number: "42.18" },
      { region: "China", year: "2010", number: "2.18" },
      { region: "China", year: "2020", number: "12.3" },
      { region: "Afghanistan", year: "2000", number: "4.1" },
      { region: "Afghanistan", year: "2010", number: "2.18" },
      { region: "Afghanistan", year: "2020", number: "1.3" },
      { region: "Bangladesh", year: "2000", number: "42.8" },
      { region: "Bangladesh", year: "2010", number: "23.18" },
      { region: "Bangladesh", year: "2020", number: "12.3" },
      { region: "Bangladesh", year: "2000", number: "2.18" },
      { region: "Bangladesh", year: "2010", number: "22.18" },
      { region: "Bangladesh", year: "2020", number: "2.3" },
      { region: "Bhutan", year: "2000", number: "2.11" },
      { region: "Bhutan", year: "2010", number: "22.12" },
      { region: "Bhutan", year: "2020", number: "2.34" },
      { region: "India", year: "2000", number: "2.16" },
      { region: "India", year: "2010", number: "22.82" },
      { region: "India", year: "2020", number: "2.12" },
      { region: "Myanmar", year: "2000", number: "2.16" },
      { region: "Myanmar", year: "2010", number: "22.82" },
      { region: "Myanmar", year: "2020", number: "2.12" },
      { region: "Pakistan", year: "2000", number: "82.1" },
      { region: "Pakistan", year: "2010", number: "52.82" },
      { region: "Pakistan", year: "2020", number: "26.12" },
      { region: "Nepal", year: "2000", number: "27.16" },
      { region: "Nepal", year: "2010", number: "22.82" },
      { region: "Nepal", year: "2020", number: "23.12" },
    ],
    decimal: 2,
    suffix: " %",
  },
];

export default Assessments;
